import React from "react"
import Head from "next/head"

import { Container, Card } from "react-bootstrap"

function TenantPriceList() {
    const url = "https://webbjenkins.co.uk/tenant-price-list/"
    const title = "Tenant Price List - Webb Jenkins"
    const description =
        "We try to make the costs for tenants as transparent as possible, do not hesitate to get in touch to clarify any misunderstandings."
    const imgUrl =
        "https://webbjenkinsstatic.imgix.net/socials/webbjenkins-tenant-fees-social.jpg"
    const imgWidth = 1200
    const imgHeight = 630
    const imgAlt = "Webb Jenkins logo with tenant price list caption"

    return (
        <>
            <Head>
                <link rel="canonical" href={url} />
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta property="fb:app_id" content="362437448786240" />
                <meta property="og:title" content={title} />
                <meta property="og:image:url" content={imgUrl} />
                <meta property="og:image:width" content={imgWidth} />
                <meta property="og:image:height" content={imgHeight} />
                <meta property="og:image:alt" content={imgAlt} />
                <meta property="og:description" content={description} />
                <meta property="og:url" content={url} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_GB" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:image:src" content={imgUrl} />
                <meta name="twitter:site" content="@WebbJenkinsIOW" />
            </Head>
            <Container fluid="md" as={Card} className="mt-5 mb-4">
                <Card.Body>
                    <Card.Title>
                        <h1 className="text-center">Tenant price list</h1>
                    </Card.Title>
                </Card.Body>
            </Container>
            <Container fluid="md" as={Card}>
                <Card.Body>
                    <p>Last updated: February 11, 2022</p>
                    <h2>New assured shorthold tenancies (ASTs)</h2>
                    <h3 className="h4">Signed on or after 1st June 2019</h3>
                    <ul>
                        <li>
                            <p>
                                <b>Holding deposit (per tenancy)</b> - One
                                week’s rent. This is only to reserve a property
                                and will be deducted from the security deposit.
                            </p>
                            <p>
                                <b>Please note:</b> this will be withheld if any
                                relevant person (including guarantor(s)): (1)
                                withdraw from the tenancy, (2) fail a
                                right-to-rent check, (3) provide materially
                                significant false or misleading information, (4)
                                fail to sign their tenancy agreement and/or deed
                                of guarantee within 15 calendar days, or other
                                deadline for agreement as mutually agreed in
                                writing.
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Security deposit</b> - Five weeks rent. This
                                covers damages or defaults on the part of the
                                tenant during the tenancy.
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>
                                    Variation of contract (tenant&apos;s
                                    request)
                                </b>{" "}
                                - £50 which covers the costs associated with
                                taking the landlord&apos;s instructions as well
                                as the preparation and execution of new legal
                                documents.
                            </p>
                        </li>
                        <li>
                            <p>
                                <b>Early termination (tenant&apos;s request)</b>{" "}
                                - Unless a tenant is found to &lsquo;take
                                over&rsquo; the tenancy, the tenant will be
                                liable to pay the rent for the remaining term of
                                the agreement.
                            </p>
                        </li>
                    </ul>
                    <p className="mt-5">
                        If you have any questions regarding these fees, please
                        contact a member of staff on{" "}
                        <a href="tel:01983 856111" role="button">
                            <b>01983 856111</b>
                        </a>{" "}
                        or via email to <b>rentals@webbjenkins.co.uk</b>.
                    </p>
                </Card.Body>
            </Container>
        </>
    )
}

export default TenantPriceList
